import zod from "zod";

export const defaultDateRange = {
  startDate: new Date("2022-01-01"),
  endDate: new Date(),
};

export const LetterBatchesFilterSchema = zod.object({
  search: zod.string(),
  startDate: zod.date().default(defaultDateRange.startDate),
  endDate: zod.date().default(defaultDateRange.endDate),
});

export type LetterBatchesFilterFormData = zod.infer<typeof LetterBatchesFilterSchema>;
